// extracted by mini-css-extract-plugin
export default {"description":"s_description__UlOvI","descriptionContainer":"s_descriptionContainer__ugvGy"};